import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivatePensionStepParams } from './types'
import { incomeSchema } from './types'

export const income = (params: PrivatePensionStepParams) => {
  const schema = incomeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_privatePension:steps.income.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_private_pension_de.shape.configuration_parameters.shape.income.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_privatePension:steps.income.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('income'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'login',
    subFlow: SubFlow.PrivatePension,
  } as const satisfies AnyStepConfiguration
}
